// Tailwind v4 default breakpoint mirror, in JS form, for the small number
// of components that need a `matchMedia` listener whose threshold has to
// stay in lockstep with a Tailwind utility prefix. The same numbers are
// also hand-typed into `globals.css` `@media (min-width: 640px)` rules —
// if the design system ever shifts a breakpoint, change it here AND in
// globals.css together.
//
// Tailwind `sm:` activates at `min-width: 40rem` (640px at the default
// root font size). The matching mobile MQ is therefore the complement.

/** Hits while the viewport is BELOW Tailwind's `sm:` threshold. */
export const MOBILE_MQ = "(width < 40rem)";

/**
 * Hits from Tailwind's `lg:` threshold up (64rem / 1024px). The mobile menu
 * closes itself here: its trigger is `lg:hidden`, so a viewport that grows past
 * this point would otherwise leave an open panel with no way to shut it.
 */
export const DESKTOP_MQ = "(width >= 64rem)";

/**
 * Hits BELOW Tailwind's `md:` threshold (48rem / 768px) — which is where
 * `<SearchComposer>` actually renders.
 *
 * ⛔ Neither of the two above is a substitute, and reaching for `MOBILE_MQ`
 * leaves a **128px dead band** (640–768px) where a control dispatches
 * `SEARCH_COMPOSER_OPEN_EVENT`, the drawer is still `md:hidden`, and the reader
 * taps something that does nothing.
 *
 * ⛔ Nor can the event's own cancel signal stand in for this. `SearchComposer`
 * is `md:hidden` — MOUNTED at every width and merely CSS-hidden above 768px —
 * so its listener calls `preventDefault()` on desktop too. The cancel signal
 * means MOUNTED, not VISIBLE.
 */
export const BELOW_MD_MQ = "(width < 48rem)";
